var map = {
	"./customer001.png": 847,
	"./customer002.png": 848,
	"./customer003.png": 849,
	"./customer004.jpg": 850,
	"./customer005.jpg": 851,
	"./customer006.png": 852,
	"./customer006.svg": 853,
	"./customer007.png": 854,
	"./customer008.jpeg": 855,
	"./customer009.png": 856,
	"./customer010.jpg": 857,
	"./customer011.jpg": 858,
	"./customer012.jpg": 859,
	"./customer013.jpg": 860,
	"./customer014.png": 861,
	"./customer015.png": 862,
	"./logo-finkey.png": 863,
	"./logo-iscab.png": 864,
	"./logo-nanoka.png": 865,
	"./logo-solire.png": 866,
	"./logo-suplamache.png": 867,
	"./me.png": 868
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;


//////////////////
// WEBPACK FOOTER
// ./src/data/img ^\.\/.*$
// module id = 127
// module chunks = 0